import React from 'react';
import { Point } from './styles.js';
import * as css from './Checkbox.module.css';
import { jsx as ___EmotionJSX } from "@emotion/react";
export default function CheckboxField(_ref) {
  var id = _ref.id,
      name = _ref.name,
      required = _ref.required,
      disabled = _ref.disabled;
  return ___EmotionJSX(Point, null, ___EmotionJSX("label", {
    className: css.label
  }, name, ___EmotionJSX("div", {
    className: css.wrap
  }, ___EmotionJSX("input", {
    type: "checkbox",
    name: name || id,
    required: required,
    disabled: disabled
  }), ___EmotionJSX("div", {
    className: css.switcher
  }))));
}